var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "events-main-header row" }, [
    _c(
      "div",
      { staticClass: "events-search-wrapper col-12 col-md-5 pb-3" },
      [
        _c("p", { staticClass: "event-filter-header" }, [
          _vm._v("Search by event name")
        ]),
        _vm._v(" "),
        _c("search-small", {
          ref: "eventsSearchBox",
          attrs: {
            placeholder: "Search by event name or category",
            "reset-value": _vm.resetFiltersFlag
          },
          on: {
            "on-keyup": _vm.updateSearchTerm,
            "on-enter": _vm.updateSearchTerm
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "events-date-picker-wrapper col-12 col-md-5 pb-3" },
      [
        _c("p", { staticClass: "event-filter-header" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("date-picker", {
          attrs: {
            "reset-value": _vm.resetFiltersFlag,
            "data-vv-validate-on": "input",
            label: "Select time frame",
            "set-min-date": true,
            range: true
          },
          on: { input: _vm.updateDateFilterValue },
          model: {
            value: _vm.dateValue,
            callback: function($$v) {
              _vm.dateValue = $$v
            },
            expression: "dateValue"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "edit-interest-wrapper col-12 col-md-2 pb-3 pt-md-4 justify-content-md-end"
      },
      [
        _c("edit-event-interests-button", {
          staticClass: "pt-1",
          attrs: { topics: _vm.topics, showSubtitle: false }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dc6f038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc6f038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/eventsByInterests/EventFeedFilters.vue
// module id = null
// module chunks = 